export default __webpack_public_path__ + "static/media/aldgLogo.124f8ef7.png";